export const MIN_DEPOSIT_AMOUNT = 100;

export interface IGetSumParams {
  source: string;
  amount?: number;
  totalAmount: number;
  balance: number;
}

export const getSum = ({ source, amount, totalAmount, balance }: IGetSumParams) => {
  if (source === 'refill') {
    return MIN_DEPOSIT_AMOUNT;
  }

  if (amount) {
    return amount;
  }

  const sum = totalAmount - balance;

  return Math.ceil(Math.abs(sum));
};
